export const CustomAppMessageType = {
  INIT: 'INIT',
  OUTGOING: {
    EXPORT_MAP: 'net.disy.cadenza.map.event.exportMap',
    LOCATION_SELECTED: 'net.disy.cadenza.map.event.locationSelected',
    SELECTION_CHANGED: 'net.disy.cadenza.map.event.selectionChanged'
  },
  INCOMING: {
    EXPORT_MAP: 'net.disy.cadenza.map.command.exportMap',
    FILTER: 'net.disy.cadenza.map.command.filter',
    FIND_LOCATION: 'net.disy.cadenza.map.command.findLocation',
    LIVE_LAYER: 'net.disy.cadenza.map.command.liveLayer',
    SELECT: 'net.disy.cadenza.map.command.changeSelection'
  }
};

export const LocationSelectedOrigin = {
  GAZETTEER: 'gazetteer',
  POINTER: 'pointer'
};
